<p><button class="btn btn-white ot-sdk-show-settings" id="ot-sdk-btn">{{'common.cookiesConf' | cxTranslate }}</button>
</p>